import { Cell } from '../../../../components/ReusableComponents/Table'
import styles from './NoteCell.module.scss'

const NoteCell = ({
  note,
  setNote,
  saveImmediately,
  loadNoteOnDemand,
  isLoading,
  isSaving,
  error
}) => (
  <Cell className={styles.noteCell}>
    <textarea
      value={note ?? ''}
      onChange={e => setNote(e.target.value)}
      onFocus={loadNoteOnDemand}
      onBlur={e => {
        const currentValue = e.target.value
        saveImmediately(currentValue)
      }}
      placeholder=" "
      disabled={isLoading}
      rows={1}
      className={styles.noteInput}
    />
    {isSaving && <span className={styles.savingIndicator}>Saving...</span>}
    {error && <div className={styles.noteError}>{error}</div>}
  </Cell>
)

export default NoteCell
